module.exports = __webpack_public_path__ + "img/subaru.97d8d17e.png";